import React, { useState } from 'react';
import { Form, Input, Button, Checkbox, Typography, Divider, Alert } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

export default function LoginForm({ onSubmit }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleFinish = async (values) => {
    setError(null);
    setLoading(true);
    try {
      const { email, password } = values || {};

      if (onSubmit) {
        await onSubmit({ email, password });
      } else {
        // Fallback démo si aucun onSubmit n'est fourni
        await new Promise((res) => setTimeout(res, 1000));
      }
    } catch (e) {
      setError(e?.message || "Identifiants invalides.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Title level={3} style={{ marginBottom: 8 }}>Connexion</Title>
      <Text type="secondary">Accédez à votre tableau de bord administrateur</Text>
      <Divider style={{ marginTop: 16, marginBottom: 16 }} />

      {error && (
        <Alert type="error" showIcon message={error} style={{ marginBottom: 16 }} />
      )}

      <Form
        layout="vertical"
        name="login"
        onFinish={handleFinish}
        initialValues={{ remember: true }}
        requiredMark={false}
      >
        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: "Veuillez renseigner votre email" },
            { type: 'email', message: "Format d'email invalide" },
          ]}
        >
          <Input
            prefix={<UserOutlined />}
            placeholder="vous@domaine.com"
            size="large"
            autoComplete="email"
          />
        </Form.Item>

        <Form.Item
          label="Mot de passe"
          name="password"
          rules={[
            { required: true, message: "Veuillez saisir votre mot de passe" },
            { min: 6, message: "Au moins 6 caractères" },
          ]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="••••••••"
            size="large"
            autoComplete="current-password"
          />
        </Form.Item>

        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 16,
          }}
        >
          <Form.Item name="remember" valuePropName="checked" noStyle>
            <Checkbox>Se souvenir de moi</Checkbox>
          </Form.Item>
          <Typography.Link href="#" onClick={(e) => e.preventDefault()}>
            Mot de passe oublié ?
          </Typography.Link>
        </div>

        <Button
          type="primary"
          htmlType="submit"
          size="large"
          block
          loading={loading}
        >
          Se connecter
        </Button>
      </Form>
    </div>
  );
}